export default __webpack_public_path__ + "static/media/NIAS0300.34I-32890_-25603_0.8bc592b5.jpg";